module.exports = __webpack_public_path__ + "5-o2.jpg?7c4dcb535a92af7892dc5f9f7c31fb75";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/5-o2.jpg
// module id = 657
// module chunks = 0